import { Provider } from '@angular/core';
import { APP_BRANDING, AppBranding } from '@features/apps/branding/app-branding';

/**
 * Branding do app Field Control - a face visual do Field na superfície de card. Todo o
 * específico do Field (logo) vive AQUI, em `features/apps/field-control`, e não no componente
 * agnóstico. A lógica da superfície continua 100% data-driven.
 */
export const FIELD_CONTROL_BRANDING: AppBranding = {
  slug: 'field-control',
  name: 'Field Control',
  logo: 'assets/logo/field-control.png',
};

/** Registra o branding do Field Control no token multi `APP_BRANDING` (usar no app.config). */
export function provideFieldControlBranding(): Provider {
  return { provide: APP_BRANDING, useValue: FIELD_CONTROL_BRANDING, multi: true };
}
